module.exports = __webpack_public_path__ + "static/media/bottomTv.fc237eb8.svg";